<form [formGroup]="formCadastrar" (submit)="OnSalvar()" aria-labelledby="form-title">
  <breadcrumb *ngIf="!ehModal" [paginas]="[
      {route:'/home',name:'Home'},
      {route:'/plano-melhoria/cadastro',name:'Cadastrar PMCE'}
    ]" aria-label="Navegação de breadcrumb" />
  <!-- FILTRO ESCOLA -->
  <section *ngIf="!ehModal" class="section-filtro" aria-labelledby="filtro-escola-title">
    <div class="container">
      <div class="grupo-filter">
        <p><b>URE</b></p>
        <ng-select [items]="diretorias" bindLabel="nomeDiretoria" bindValue="codigoDiretoria"
          placeholder="Selecione uma URE" formControlName="codigoDiretoria" name="codigoDiretoria"
          [ngClass]="{ 'is-invalid': submitted && form.codigoDiretoria.errors }" (change)="getEscolas()"
          aria-describedby="diretoria-error">
        </ng-select>
        <div *ngIf="submitted && form.codigoDiretoria.errors" class="alert">
          <div *ngIf="form.codigoDiretoria.errors.required">
            * URE é obrigatório
          </div>
        </div>
      </div>

      <div class="grupo-filter">
        <p><b>Escola</b></p>
        <div style="display: flex; align-items: flex-end; gap: 8px;">
          <ng-select [items]="escolas" bindLabel="nomeEscola" bindValue="codigoEscola" placeholder="Selecione uma Escola"
            formControlName="codigoEscola" name="codigoEscola"
            [ngClass]="{ 'is-invalid': submitted && form.codigoEscola.errors }" aria-describedby="escola-error">
          </ng-select>
          <button type="button" class="btn_primary" style="height: 40px;" (click)="OnPesquisar()">
            <i class="fa fa-search"></i> Pesquisar
          </button>
        </div>
        <div *ngIf="submitted && form.codigoEscola.errors" class="alert">
          <div *ngIf="form.codigoEscola.errors.required">
            * Escola é obrigatório
          </div>
        </div>
      </div>

    </div>
  </section>

  <!-- TITULO -->
  <section *ngIf="!ehModal" class="section-saudacao">
    <div class="container header-page">
      <h2 class="titulo-page">Plano da Melhoria de Convivência Escolar - PMCE</h2>

      <button type="button" class="btn_primary" id="btn-cadastrar-plano" aria-label="Cadastrar plano"
        (click)="OnOpenModal(); $event.stopPropagation()">
        <i class="fa-plus fa-solid icon-white"></i>
        <span>Cadastrar plano</span>
      </button>

    </div>
  </section>

  <!-- TITULO MODAL -->
  <section *ngIf="ehModal" class="conteudo-principal" aria-labelledby="detalhes-chamado-title">
    <h2 class="font-modal-acao">{{ tituloAcaoModal }}</h2>
    <br />
    <section>
      <h3 class="info-plano text-dark margin-bottom-20">Informação do Plano</h3>
      <h4 *ngIf="statusPlano !== null && statusPlano !== undefined" class="info-plano-status text-muted">Status</h4>
      <div *ngIf="statusPlano !== null && statusPlano !== undefined" class="status-container">
        <span class="status-circle span-status-circle" [ngClass]="{
          'status-novo': statusPlano === 0,
          'status-validacao-supervisor-Ensino': statusPlano === 1,
          'status-validacao-pec-conviva': statusPlano === 2,
          'status-devolvido-ajustes': statusPlano === 3,
          'status-aprovado': statusPlano === 4,
          'sem-status': statusPlano === null || statusPlano === undefined
        }"></span>
        <span class="status-text">{{
          statusPlano === 0 ? 'Novo' :
          statusPlano === 1 ? 'Aguardando Validação Supervisor de Ensino' :
          statusPlano === 2 ? 'Aguardando Validação PEC CONVIVA' :
          statusPlano === 3 ? 'Devolvido para ajustes' :
          statusPlano === 4 ? 'Aprovado' : ''
          }}</span>
      </div>
    </section>
    <br /><br />
  </section>

  <!-- FORMULARIO PLANO MELHORIA -->
  <section *ngIf="ehModal" class="conteudo-principal" aria-labelledby="detalhes-chamado-title">
    <div class="container-conviva form-registro">
      <div class="time-line conteudo-registro">

        @if (statusPlano == 3 && planoMelhoria?.justificativa)
        {
          <div class="conteudo-textarea">
            <label for="statusPlano">
              Motivo da Reprovação
            </label>
            <textarea id="justificativa" name="justificativa" formControlName="justificativa" rows="3" cols="50" readonly>{{planoMelhoria?.justificativa}}</textarea>
          </div>
        }

        <div class="conteudo-select conteudo-ano">
          <label for="ano">
            Ano
          </label>
          <input type="number" id="ano" name="ano" class="input-date" formControlName="ano"
            placeholder="Selecione o ano" aria-label="Ano" (input)="limitarAno($event)"
            [ngClass]="{ 'is-invalid': submitted && form.ano.errors }" />
          <div *ngIf="submitted && form.ano.errors" class="alert">
            <div *ngIf="form.ano.errors?.required">
              * Ano é obrigatório.
            </div>
            <div *ngIf="form.ano.errors?.min">
              * O Ano não pode ser menor que 2025.
            </div>
            <div *ngIf="form.ano.errors?.max">
              * O Ano não pode ser maior que 2099.
            </div>
          </div>
        </div>

        <!-- <div class="conteudo-select">
          <label>
            Episódios mais recorrentes
          </label>
          <div class="mt-1" *ngFor="let subcategoria of subCategoriasComMaisOcorrencias">
            <input type="text"
                   class="input-date"
                   value="{{subcategoria.descricaoSubCategoria}}"
                   disabled />
          </div>
          @if (subCategoriasComMaisOcorrencias.length == 0)
          {
          <div class="p-3">
          </div>
          }
        </div> -->

        <div class="conteudo-textarea">
          <label for="dsMetas">
            Diagnóstico (Considerar dados da Plataforma Conviva)
          </label>
          <textarea id="dsMetas" name="dsMetas" rows="6" cols="50" formControlName="dsMetas" minlength="1"
            maxlength="2000" placeholder="Insira o diagnóstico do plano" (keyup)="OnChangeCountLettersMetas()"
            [ngClass]="{ 'is-invalid': submitted && form.dsMetas.errors }"
            aria-describedby="descricao-error"></textarea>
          <p class="fs-5">Quantidade de caracteres atual: {{qtdeCaracteresMetas}}</p>
          <div *ngIf="submitted && form.dsMetas.errors" class="alert">
            <div *ngIf="form.dsMetas.errors?.required">
              * Diagnóstico é obrigatório.
            </div>
            <div *ngIf="form.dsMetas.errors?.minlength">
              * É obrigatório no mínimo digitar 1 caracteres.
            </div>
            <div *ngIf="form.dsMetas.errors?.maxlength">
              * Maximo de caracteres é 2000.
            </div>
          </div>
        </div>

        <div class="conteudo-textarea">
          <label for="dsMetas">
            Objetivos (Definição clara do problema e do resultado esperado)
          </label>
          <textarea id="dsDesafios" name="dsDesafios" rows="6" cols="50" formControlName="dsDesafios" minlength="1"
            maxlength="2000" placeholder="Insira os objetivos do plano" (keyup)="OnChangeCountLettersDesafios()"
            [ngClass]="{ 'is-invalid': submitted && form.dsDesafios.errors }"
            aria-describedby="descricao-error"></textarea>
          <p class="fs-5">Quantidade de caracteres atual: {{qtdeCaracteresDesafios}}</p>
          <div *ngIf="submitted && form.dsDesafios.errors" class="alert">
            <div *ngIf="form.dsDesafios.errors?.required">
              * Objetivos é obrigatório.
            </div>
            <div *ngIf="form.dsDesafios.errors?.minlength">
              * É obrigatório no mínimo digitar 1 caracteres.
            </div>
            <div *ngIf="form.dsDesafios.errors?.maxlength">
              * Maximo de caracteres é 2000.
            </div>
          </div>
        </div>

        <!-- <div class="conteudo-textarea">
          <label for="dsTemas">
            Principais temas a serem trabalhados durante o ano
          </label>
          <textarea id="dsTemas"
                    name="dsTemas"
                    rows="6"
                    cols="50"
                    formControlName="dsTemas"
                    minlength="1"
                    maxlength="2000"
                    (keyup)="OnChangeCountLettersTemas()"
                    [ngClass]="{ 'is-invalid': submitted && form.dsTemas.errors }"
                    aria-describedby="descricao-error"></textarea>
          <p class="fs-5">Quantidade de caracteres atual: {{qtdeCaracteresTemas}}</p>
          <div *ngIf="submitted && form.dsTemas.errors" class="alert">
            <div *ngIf="form.dsTemas.errors?.required">
              * Principais temas a serem trabalhados durante o ano é obrigatório.
            </div>
            <div *ngIf="form.dsTemas.errors?.minlength">
              * É obrigatório no mínimo digitar 1 caracteres.
            </div>
            <div *ngIf="form.dsTemas.errors?.maxlength">
              * Maximo de caracteres é 2000.
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </section>

  <!-- MODAL FORMULÁRIO AÇÕES -->
  <section *ngIf="ehModal && formModal" class="modalCadastroAcoes" [formGroup]="formModal">
    <div class="container-conviva form-registro modal-envolvidos">

      <h2 class="font-modal-acao margin-bottom-20">Ações adicionadas</h2>


      <div formArrayName="acoes">

        <div *ngFor="let acao of acoesFormArray.controls; let i = index" [formGroupName]="i" class="acao-card">

          <!-- CABEÇALHO -->
          <div class="acao-header" (click)="toggleAcao(i)">
            <span>Ação {{ i + 1 }}</span>
            <span class="icone">
              <i class="fa-solid" [ngClass]="acaoAbertaIndex === i ? 'fa-chevron-up' : 'fa-chevron-down'">
              </i>
            </span>
          </div>

          <!-- CONTEÚDO -->
          <div class="acao-body" *ngIf="acaoAbertaIndex === i">

            <!-- TEMA -->
            <div class="conteudo-textarea">
              <label>Tema e descrição da ação*</label>
              <textarea rows="3" formControlName="dsTemaAcao" minlength="300" maxlength="2000" (keyup)="OnChangeCountLettersTemaAcao(i)" [ngClass]="{ 'is-invalid': submittedModal && acao.errors?.dsTemaAcao }" aria-describedby="tema-acao-error"></textarea>
              <div class="fs-5">Quantidade de caracteres atual: {{qtdeCaracteresTemaAcao[i] || 0}}</div>
              <div *ngIf="submittedModal && acao.errors?.dsTemaAcao" class="alert">
                <div *ngIf="acao.get('dsTemaAcao')?.errors?.required">
                  * O campo 'Tema e descrição da ação' é obrigatório.
                </div>
                <div *ngIf="acao.get('dsTemaAcao')?.errors?.minlength">
                  * O campo 'Tema e descrição da ação' deve conter no mínimo 300 caracteres.
                </div>
                <div *ngIf="acao.get('dsTemaAcao')?.errors?.maxlength">
                  * Máximo de caracteres é 2000.
                </div>
              </div>
            </div>

            <!-- PÚBLICO -->
            <div class="conteudo-select">
              <label>Público</label>
              <ng-select [items]="publico" bindLabel="name" bindValue="id" formControlName="dsPublico">
              </ng-select>
            </div>


            <!-- RESPONSÁVEL -->
            <!-- <div class="conteudo-textarea">
              <label>Responsável pela ação</label>
              <text rows="1" formControlName="dsResponsavel"></text>
            </div> -->



            <div class="conteudo-textarea">
              <label for="dsOutraParceria">
                Parceria com a rede protetiva/outras parcerias *
              </label>
              <textarea id="dsOutraParceria" name="dsOutraParceria" rows="1" formControlName="dsOutraParceria"
                minlength="1" maxlength="500" (keyup)="OnChangeCountLettersOutraParceria(i)"
                [ngClass]="{ 'is-invalid': submittedModal && acao.get('dsOutraParceria')?.errors }"
                aria-describedby="descricao-error"></textarea>
              <div *ngIf="submittedModal && acao.get('dsOutraParceria')?.errors" class="alert">
                <div *ngIf="acao.get('dsOutraParceria')?.errors?.required">
                  * Outras parcerias é obrigatório.
                </div>
              </div>
            </div>

            <!-- AÇÃO -->
            <!-- <div class="conteudo-textarea">
            <label>Ação a ser realizada</label>
            <textarea rows="3"[id]="dsAcao" name="dsAcao" formControlName="dsAcao"></textarea>
          </div> -->

            <!-- RESPONSÁVEL -->
            <div class="conteudo-textarea">
              <label>Responsável pela ação*</label>
              <textarea rows="1" formControlName="dsResponsavel"></textarea>
            </div>



            <!-- DATA -->
            <!-- <div class="conteudo-select">
            <label>Data</label>
            <input type="date" formControlName="dataAcao" />
          </div> -->

            <!-- BIMESTRE -->
            <div class="conteudo-select">
              <label>Bimestre</label>
              <ng-select [items]="bimestres" bindLabel="name" bindValue="id" formControlName="nrBimestre">
              </ng-select>
            </div>

             <div *ngIf="ehModal && (getArquivosAcao(i).length > 0 || podeExibirUploadEvidencia(i))" class="conteudo-upload grupo-filter-full">

              <label class="evidencias-titulo">
                Evidências de execução(registros e comprovações das ações realizadas por ação)
              </label>
              <p class="sem-evidencias" *ngIf="getArquivosAcao(i).length === 0 && !podeExibirUploadEvidencia(i)">
                Nenhuma evidência foi adicionada.
              </p>

              <div class="evidencias-box">

                <div *ngIf="podeExibirUploadEvidencia(i)" class="evidencias-controles">
                  <input type="file" [id]="'arquivos-' + i" name="Files" accept=".jpg,.jpeg,.png,.pdf,.mp3,.mp4"
                    (change)="OnFileChange($event, i)" multiple hidden class="input-file-hidden" />

                  <label [for]="'arquivos-' + i" class="btn-anexar">
                    <i class="fa fa-paperclip"></i>
                    Anexar evidências
                  </label>

                  <button type="button" class="btn-salvar-evidencia" (click)="SalvarEvidenciaAcao(i)">
                    <i class="fa fa-save"></i>
                    Salvar Evidência
                  </button>

                  <div *ngIf="getArquivosEvidenciaPendentes(i).length > 0" class="arquivos-pendentes">
                    <span *ngFor="let file of getArquivosEvidenciaPendentes(i)">
                      {{ file.name }}
                    </span>
                  </div>
                </div>


                <div *ngIf="getArquivosAcao(i).length > 0" class="imagem-escolhida">
                  <div *ngFor="let file of getArquivosAcao(i); let fileIndex = index">
                    <app-card-arquivo-anexado [arquivo]="file" [index]="fileIndex"
                      [showRemoveButton]="podeExibirUploadEvidencia(i)"
                      (visualizar)="visualizarAquivo($event, i)" (download)="DownloadArquivo($event, i)"
                      (remover)="popupremoverarquivo($event, i)">
                    </app-card-arquivo-anexado>
                  </div>
                </div>
              </div>
            </div>



            <!-- REMOVER -->
            <button type="button" class="btn-remover-pill" (click)="removerAcao(i)"
              [disabled]="ehEdit && getTamanhoAcoes() === 1"
              [title]="ehEdit && getTamanhoAcoes() === 1 ? 'Não é possível remover a última ação em modo de edição' : ''">
              <i class="fa fa-trash"></i>
              <span>Remover ação</span>
            </button>

          </div>
        </div>

      </div>
    </div>
  </section>

  <!-- FORMULARIO PLANO MELHORIA AÇÕES -->
  <section class="conteudo-principal" aria-labelledby="detalhes-chamado-title">

    <div class="container-conviva form-registro">
      <div class="time-line conteudo-registro" style="border-radius: 0 0 3.2rem 3.2rem;">
        <button *ngIf="ehModal" type="button" class="btn_outline" role="button" id="btnAdicionar" name="b2"
          aria-label="Adicionar ação" (click)="OnCadastrarAcao()" style="width:185px;">
          <i class="fa-plus fa-solid icon-primary"></i>&nbsp;
          <span>Adicionar ação</span>
        </button>
        <!-- Confirmação dos responsáveis -->
        <section *ngIf="!ehReadOnly && ehModal" class="declaracao" style="margin-top: 15px;">
          <h3 class="margin-bottom-20">Declaração</h3>

          <div class="declaracao-conteudo">

            <input type="checkbox" id="cienciaResponsaveis" formControlName="cienciaResponsaveis"
              [disabled]="ehReadOnly" [ngClass]="{
                'is-invalid': submitted && form.cienciaResponsaveis.errors
              }" />

            <label for="cienciaResponsaveis" class="declaracao-texto">
              Declaro, na qualidade de integrante da equipe gestora (diretor/vice) da
              Unidade Escolar, que todas as pessoas citadas como responsáveis neste
              plano foram devidamente informadas e estão cientes de suas atribuições,
              compromissos e responsabilidades no âmbito das ações previstas.
            </label>
          </div>
        </section>

        <!-- <div style="margin-top: 15px;">
              <label class="checkbox-wrapper">
                <input *ngIf="ehReadOnly"
                              type="checkbox"
                              [checked]="true"
                              disabled />
                 <input *ngIf="!ehReadOnly"
                              type="checkbox"
                              formControlName="cienciaResponsaveis"
                              [ngClass]="{ 'is-invalid': submitted && form.cienciaResponsaveis.errors }" />
                <span>
                  Declaro, na qualidade de Diretor(a) da Unidade Escolar, que todas
                  as pessoas citadas como responsáveis neste plano foram devidamente
                  informadas e estão cientes de suas atribuições, compromissos e
                  responsabilidades no âmbito das ações previstas.
                </span>
              </label>

              <div *ngIf="submitted && form.cienciaResponsaveis.errors" class="alert">
                <div>
                  *Todos os envolvidos devem estar cientes para continuar.
                </div>
              </div>
            </div> -->
        <div class="container-btns mt-5">
          <!-- <input *ngIf="!ehReadOnly" type="button" class="btn_outline" id="btnLimpar" name="b2" value="Limpar" aria-label="Limpar" (click)="OnLimpar()" />
          <input *ngIf="!ehReadOnly" type="submit" class="btn_primary" value="Salvar" aria-label="Salvar" />
          <input *ngIf="ehModal" type="button" class="btn_outline" id="btnFechar" name="b2" value="Fechar" aria-label="Fechar" (click)="fechar.emit()" /> -->
          <input *ngIf="ehModal && (tituloAcaoModal === 'Cadastrar plano' || tituloAcaoModal === 'Editar plano')" type="button"
            class="btn_outline" id="btnModalCangicelar" name="btnModalCancelar" value="Cancelar" aria-label="Cancelar"
            (click)="fechar.emit()" />
          <input *ngIf="ehModal && tituloAcaoModal === 'Visualizar plano'" type="button" class="btn_outline" id="btnModalDownload"
            name="btnModalDownload" value="Download do Plano" aria-label="Download do Plano"(click)="gerarPDFPlano()" />
          <input *ngIf="ehModal && tituloAcaoModal === 'Visualizar plano' && !NaoPodeAlterar" type="button" class="btn_outline" id="btnModalEditar"
            name="btnModalEditar" value="Editar plano" aria-label="Editar plano" (click)="liberarEdicao()" />
          <input *ngIf="ehModal && tituloAcaoModal === 'Cadastrar plano'" type="button" class="btn_primary"
            id="btnModalCadastrarPlano" value="Cadastrar plano" aria-label="Cadastrar plano" (click)="OnSalvar()" />
          <input *ngIf="ehModal && tituloAcaoModal === 'Visualizar plano'" type="button" class="btn_primary" id="btnModalFechar"
            value="Fechar" aria-label="Fechar" (click)="fechar.emit()" />
          <input *ngIf="ehModal && tituloAcaoModal === 'Editar plano'" type="button" class="btn_primary"
            id="btnModalSalvarAlteracoes" value="Salvar alterações" aria-label="Salvar alterações"
            (click)="OnSalvar()" />
        </div>
      </div>
    </div>
  </section>
</form>

<section *ngIf="!ehModal" class="conteudo-principal mt-5 pt-5" aria-labelledby="detalhes-chamado-title">
  <div class="container-conviva form-registro container-grid grid-pmce">
    <app-tabulator-table [tableData]="lstPlanosMelhoria" [columnNames]="colunasGridPMCE" [mostrarExportarHtml]="false"
      [tipoRelatorio]="3" [orientacaoPortrait]="false" [mostrarFiltro]="false"
      [legendaHtml]="legendaEvidenciasGrid"></app-tabulator-table>
  </div>
</section>

<app-modal *ngIf="showCadastroModal" class="modal-cadastrar">
  <div class="container-conviva form-registro modal-envolvidos">
    <app-plano-melhoria-cadastro [planoMelhoria]="planoSelecionado" [ehModal]="true" [ehEdicao]="ehEdit"
      [tituloAcaoModal]="tituloAcaoModal" [statusPlano]="statusPlano"
      [codigoEscolaFiltroModal]="codigoEscolaModalSelecionada"
      [codigoDiretoriaFiltroModal]="codigoDiretoriaModalSelecionada"
      (planoAtualizado)="OnPlanoEvidenciasAtualizado($event)"
      (fechar)="FecharCadastroModal()">
    </app-plano-melhoria-cadastro>
  </div>
</app-modal>


<!-- Modal de Exclusão -->
<app-modal *ngIf="showModalExcluirPlano">
  <div class="container-conviva form-registro modal-envolvidos">

    <div class="card-modal">
      <div class="card-header-icon card-header--vermelho margin-bottom-20">
        <i class="fa-solid fa-times-circle" title="Enviar para a Validação"></i>
      </div>
      <div class="card-body">
        <h3 class="card-title card-title--vermelho margin-bottom-20">{{ descricaoModal }}</h3>
        <p class="card-paragraph">Detalhes:</p>
        <div class="box-info-modal">
          <span class="label">Ano</span>
          <span class="valor">{{ anoModal }}</span>
        </div>
        <div class="box-info-modal">
          <span class="label">Escola</span>
          <span class="valor">{{ escolaModal }}</span>
        </div>
        <span class="container-btns margin-top-20"></span>
        <div class="container-btns">
          <input type="button" (click)="FecharModalExclusao()" class="btn_outline btn_outline--danger"
            value="Cancelar" />
          <input type="button" (click)="DeletePlano()" class="btn_primary btn_primary--danger" value="Confirmar" />
        </div>

      </div>
    </div>

  </div>
</app-modal>

<!-- Modal de Enviar para Validação Supervisor -->
<app-modal *ngIf="showModalEnviarPlanoValidacao">
  <div class="container-conviva form-registro modal-envolvidos">

    <div class="card-modal">
      <div class="card-header-icon card-header--azul margin-bottom-20">
        <i class="fa-solid fa-arrows-rotate" title="Enviar para a Validação"></i>
      </div>
      <div class="card-body">
        <h3 class="card-title card-title--azul margin-bottom-20">{{ descricaoModal }}</h3>
        <div class="callout-danger">
          <i class="fa-solid fa-circle-exclamation"></i>
          <p>
            <strong>Atenção:</strong>
            Depois da aprovação, a única modificação permitida será a inclusão de ações e o envio de evidências.
          </p>
        </div>
        <p class="card-paragraph margin-top-20">Detalhes:</p>
        <div class="box-info-modal">
          <span class="label">Ano</span>
          <span class="valor">{{ anoModal }}</span>
        </div>
        <div class="box-info-modal">
          <span class="label">Escola</span>
          <span class="valor">{{ escolaModal }}</span>
        </div>
        <span class="margin-bottom-20"></span>
        <div class="container-btns margin-top-20">
          <input type="button" (click)="FecharModalEnviarValidacao()" class="btn_outline" value="Cancelar" />
          <input type="button" (click)="EnviarPlanoParaValidacao()" class="btn_primary" value="Confirmar" />
        </div>

      </div>
    </div>

  </div>
</app-modal>

<app-modal *ngIf="showModalDeletarArquivo">
  <div class="container-conviva form-registro modal-envolvidos">
    <div>
      <h1 class="titulo-page">Tem certeza que deseja excluir o anexo?</h1>
    </div>
    <div class="descricao-modal-excluir">
      <span>Atenção: </span>não será possível desfazer esta ação.<br><br>
      <span>Detalhes</span><br>
      {{arquivoRemover?.nomeOriginal}}<br>
    </div>
    <div class="container-btns">
      <input type="button" (click)="FecharModalDeletarArquivo()" class="btn_outline" value="Cancelar" />
      <input type="button" (click)="removeFile()" class="btn_primary" value="Confirmar" />
    </div>
  </div>
</app-modal>

<app-modal *ngIf="showModalVisualizarArquivo && arquivoVisualizando">
  <app-visualizar-arquivo [arquivo]="arquivoVisualizando"
    (fechar)="fecharModalVisualizarArquivo()"></app-visualizar-arquivo>
</app-modal>

<!-- Modal de Aprovação do Plano (PEC/Supervisor) -->
<app-modal *ngIf="showModalAprovarPlano">
  <div class="modal-plano-melhoria">
    <div class="imagen">
      <img src="../../../../assets/img/elemento/elemento-aprovar.svg" alt="Aprovar" />
    </div>
    <div class="container-conviva form-registro modal-envolvidos">
      <div class="header-modal-calendario">
        <h2 class="titulo-page">
          Tem certeza de que deseja aprovar?
        </h2>
        <div class="row alert-attention">
          <i class="fa fa-exclamation-circle"></i>
          <p>
            <strong>Atenção:</strong> Depois da aprovação, a única modificação permitida será a inclusão de ações e o envio de evidências.
          </p>
        </div>
        <h4>Detalhes</h4>
        <div class="card-detalhes">
          <p>Ano</p>
          <p><strong>{{ planoSelecionado?.anoLetivo }}</strong></p>
        </div>
        <div class="card-detalhes">
          <p>Escola</p>
          <p><strong>{{ planoSelecionado?.nomeEscola }}</strong></p>
        </div>
      </div>
      <div class="container-btns pt-5">
        <input type="button" class="btn_outline" value="Cancelar" (click)="FecharModalAprovar()" aria-label="Cancelar" />
        <input type="button" class="btn_primary" value="Confirmar" (click)="ConfirmarAprovacaoPlano()" aria-label="Confirmar" />
      </div>
    </div>
  </div>
</app-modal>

<!-- Modal de Devolução do Plano (PEC/Supervisor) -->
<app-modal *ngIf="showModalDevolverPlano">
  <div class="modal-plano-melhoria">
    <div class="imagen">
      <img src="../../../../assets/img/elemento/elemento-reprovar.svg" alt="Reprovar" />
    </div>
    <form [formGroup]="formValidacaoPec" (submit)="ConfirmarReprovacaoPlano()">
      <div class="container-conviva form-registro modal-envolvidos">
        <div class="header-modal-calendario">
          <h2 class="titulo-page">
            Tem certeza de que deseja reprovar?
          </h2>
          <h4>Detalhes</h4>
          <div class="card-detalhes">
            <p>Ano</p>
            <p><strong>{{ planoSelecionado?.anoLetivo }}</strong></p>
          </div>
          <div class="card-detalhes">
            <p>Escola</p>
            <p><strong>{{ planoSelecionado?.nomeEscola }}</strong></p>
          </div>
        </div>
        <div>
          <div class="conteudo-textarea">
            <label for="dsJustificativaPec">
              Motivo da reprovação:
            </label>
            <textarea id="dsJustificativaPec"
                      name="dsJustificativa"
                      rows="6"
                      cols="50"
                      formControlName="dsJustificativa"
                      minlength="150"
                      maxlength="1000"
                      (keyup)="OnChangeCountLettersJustificativaPec()"
                      [ngClass]="{ 'is-invalid': submitted && formValidacaoPec.get('dsJustificativa')?.errors }"
                      aria-describedby="descricao-error"></textarea>
            <p class="fs-5">Quantidade de caracteres atual: {{qtdeCaracteresJustificativaPec}}</p>
            <div *ngIf="submitted && formValidacaoPec.get('dsJustificativa')?.errors" class="alert">
              <div *ngIf="formValidacaoPec.get('dsJustificativa')?.errors?.['required']">
                * Motivo da reprovação é obrigatório.
              </div>
              <div *ngIf="formValidacaoPec.get('dsJustificativa')?.errors?.['minlength']">
                * É obrigatório no mínimo digitar 150 caracteres.
              </div>
              <div *ngIf="formValidacaoPec.get('dsJustificativa')?.errors?.['maxlength']">
                * Maximo de caracteres é 1000.
              </div>
            </div>
          </div>
        </div>
        <div class="container-btns pt-5">
          <input type="button" class="btn_outline" value="Cancelar" (click)="FecharModalDevolver()" aria-label="Cancelar" />
          <input type="submit" class="btn_primary" value="Confirmar" aria-label="Confirmar" />
        </div>
      </div>
    </form>
  </div>
</app-modal>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Carregando ...</p>
</ngx-spinner>
